import { Subtitle } from '@core/types';

export const SubtitleDisplay = ({ activeSubtitles, isMobile, isPaused }: { activeSubtitles: Subtitle[]; isMobile?: boolean; isPaused?: boolean }) => {
    return (
        <div className={`absolute bottom-1/50 w-full text-white text-center text-[clamp(16px,2.5cqw,48px)] leading-[1.2] px-4 ${isPaused ? (isMobile ? 'mb-[48px]' : 'mb-[72px]') : (isMobile ? 'group-focus-visible:/video:mb-[48px] group-hover/video:mb-[48px]' : 'group-focus-visible:/video:mb-[72px] group-hover/video:mb-[72px]')} pointer-events-none motion-safe:transition-[margin-bottom] ease-out`}>
            {activeSubtitles.map((subtitle, index) =>
                subtitle.lines.map((line, lineIndex) => (
                    <div className="max-w-full" key={`${index}-${lineIndex}`}>
                        <span className="bg-black/75 rounded-[0.16667em] box-decoration-clone px-2 whitespace-pre-wrap">
                            {line}
                        </span>
                    </div>
                ))
            )}
        </div>
    );
};